import React from "react";
import { Link } from "react-router-dom";
import {
  NavigationMenu,
  NavigationMenuList,
  NavigationMenuItem,
} from "@/components/ui/navigation-menu";
import { SmoothScrollLink } from "./SmoothScrollLink";

export const DesktopNav = () => {
  return (
    <div className="flex items-center justify-center w-full relative">
      <NavigationMenu className="hidden md:block absolute left-1/2 transform -translate-x-1/2">
        <NavigationMenuList className="flex gap-8">
          <NavigationMenuItem>
            <SmoothScrollLink to="#home" className="text-sm font-medium hover:text-primary">
              Chat
            </SmoothScrollLink>
          </NavigationMenuItem>
          <NavigationMenuItem>
            <SmoothScrollLink to="#inspirational-ai" className="text-sm font-medium hover:text-primary">
              Inspirational AI
            </SmoothScrollLink>
          </NavigationMenuItem>
          <NavigationMenuItem>
            <SmoothScrollLink to="#self-directed-ai" className="text-sm font-medium hover:text-primary">
              Self-directed AI
            </SmoothScrollLink>
          </NavigationMenuItem>
          <NavigationMenuItem>
            <SmoothScrollLink to="#system-status" className="text-sm font-medium hover:text-primary">
              System Status
            </SmoothScrollLink>
          </NavigationMenuItem>
          <NavigationMenuItem>
            <SmoothScrollLink to="#about" className="text-sm font-medium hover:text-primary">
              About
            </SmoothScrollLink>
          </NavigationMenuItem>
        </NavigationMenuList>
      </NavigationMenu>
    </div>
  );
};
